/**
 * Truncate a long filename for compact displays, keeping the extension
 * visible: "99977_Screensho....pdf" instead of a name that wraps across
 * two lines.
 */
export function truncateFilename(filename, max = 24) {
    if (typeof filename !== 'string') return filename;
    if (filename.length <= max) return filename;

    const dot = filename.lastIndexOf('.');
    if (dot <= 0 || dot === filename.length - 1) {
        // No usable extension; truncate from the end.
        return filename.slice(0, max - 3) + '...';
    }

    const ext = filename.slice(dot);
    return filename.slice(0, max - ext.length - 3) + '...' + ext;
}